import { t } from '@lingui/macro'
import * as TooltipPrimitive from '@radix-ui/react-tooltip'
import * as React from 'react'
const tooltipBgColor = 'rgba(0, 0, 0, 0.9)' // eslint-disable-line string-to-lingui/missing-lingui-transformation

function TooltipProvider({ delayDuration = 0, ...props }: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
    return <TooltipPrimitive.Provider data-slot='tooltip-provider' delayDuration={delayDuration} {...props} />
}

function Tooltip({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Root>) {
    return (
        <TooltipProvider>
            <TooltipPrimitive.Root data-slot='tooltip' {...props} />
        </TooltipProvider>
    )
}

function TooltipTrigger({ ...props }: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
    return <TooltipPrimitive.Trigger data-slot='tooltip-trigger' {...props} />
}

function TooltipContent({ className, sideOffset = 4, children, ...props }: React.ComponentProps<typeof TooltipPrimitive.Content>) {
    return (
        <TooltipPrimitive.Portal>
            <TooltipPrimitive.Content
                data-slot='tooltip-content'
                sideOffset={sideOffset}
                style={{
                    backgroundColor: tooltipBgColor,
                    color: 'white',
                    zIndex: 9999,
                    width: 'fit-content',
                    borderRadius: '6px',
                    padding: '6px 12px',
                    fontSize: '12px',
                    fontWeight: 500,
                    textAlign: 'center',
                    animation: 'fadeIn 0.2s ease', // eslint-disable-line string-to-lingui/missing-lingui-transformation
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)',
                    opacity: 1,
                    backdropFilter: 'none',
                    WebkitBackdropFilter: 'none'
                }}
                aria-label={t`Tooltip`}
                {...props}
            >
                {children}
                <TooltipPrimitive.Arrow
                    style={{
                        backgroundColor: tooltipBgColor,
                        fill: tooltipBgColor,
                        zIndex: 9999,
                        width: '10px',
                        height: '10px',
                        transform: 'translateY(calc(-50% - 2px)) rotate(45deg)',
                        borderRadius: '2px'
                    }}
                />
            </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
    )
}

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }
